module.exports = __webpack_public_path__ + "media/images/common/ico_05-f6cf18ecccdb5c7ccc19eaaf9591e8af.png";